<!-- New Tailwind-based Layout -->
<div class="flex bg-brand-bg"
     [class.min-h-screen]="!isContentFillMode"
     [class.h-screen]="isContentFillMode"
     [class.overflow-hidden]="isContentFillMode">

  <!-- Sidebar Navigation -->
  <aside class="fixed inset-y-0 left-0 z-50 w-64 bg-brand-navy transform transition-transform duration-300 lg:translate-x-0 flex flex-col"
         [class.translate-x-0]="sidebarVisible"
         [class.-translate-x-full]="!sidebarVisible">

    <!-- Logo Area (fixed height) -->
    <div class="h-16 flex-shrink-0 flex items-center justify-center bg-brand-navy-dark border-b border-white/10">
      <img src="assets/images/500px_parseeasy.png" alt="ParseEasy" class="h-9 object-contain">
    </div>

    <!-- Navigation (scrollable) -->
    <nav class="flex-1 overflow-y-auto scrollbar-hide py-4" data-tour="sidebar-nav">
      <div *ngFor="let section of navSections" class="mb-6">
        <h3 class="px-5 mb-2 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
          {{ section.title }}
        </h3>
        <div class="flex flex-col gap-1.5 px-2">
        <a *ngFor="let item of section.items"
           [routerLink]="item.route"
           [queryParams]="item.queryParams || null"
           routerLinkActive="nav-active"
           [routerLinkActiveOptions]="{exact: item.exact || item.route === '/dashboard'}"
           [attr.data-tour]="getTourId(item)"
           class="customer-nav-link flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-300 hover:text-white hover:bg-white/5 transition-colors cursor-pointer group">
          <svg class="w-[18px] h-[18px] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <ng-container [ngSwitch]="item.icon">
              <ng-container *ngSwitchCase="'dashboard'">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </ng-container>
              <ng-container *ngSwitchCase="'documents'">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'activity'">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </ng-container>
              <ng-container *ngSwitchCase="'playground'">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </ng-container>
              <ng-container *ngSwitchCase="'template'">
                <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                <polyline points="13 2 13 9 20 9"></polyline>
              </ng-container>
              <ng-container *ngSwitchCase="'add'">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'key'">
                <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'webhook'">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </ng-container>
              <ng-container *ngSwitchCase="'analytics'">
                <line x1="12" y1="20" x2="12" y2="10"></line>
                <line x1="18" y1="20" x2="18" y2="4"></line>
                <line x1="6" y1="20" x2="6" y2="16"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'report'">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'billing'">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                <line x1="1" y1="10" x2="23" y2="10"></line>
              </ng-container>
              <ng-container *ngSwitchCase="'settings'">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'support'">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </ng-container>
              <ng-container *ngSwitchCase="'help'">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </ng-container>
            </ng-container>
          </svg>
          <span class="text-sm font-medium">{{ item.label }}</span>
          <span *ngIf="item.badge" class="ml-auto bg-brand-crimson text-white text-[10px] font-semibold px-2 py-0.5 rounded-full">
            {{ item.badge }}
          </span>
        </a>
        </div>
      </div>

      <!-- Collapsed nav: reveal Advanced until first parse -->
      <div *ngIf="collapsedNavEnabled && !showAdvancedNav" class="px-4 mb-4">
        <button
          type="button"
          (click)="expandAdvancedNav()"
          data-tour="nav-show-more"
          class="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 transition-all text-sm font-medium border border-white/10">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
          Show more
        </button>
      </div>

    </nav>
  </aside>

  <!-- Sidebar Overlay (Mobile) -->
  <div class="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
       [class.opacity-100]="sidebarVisible"
       [class.opacity-0]="!sidebarVisible"
       [class.pointer-events-none]="!sidebarVisible"
       (click)="toggleSidebar()">
  </div>

  <!-- Main Content Area -->
  <main class="flex-1 lg:ml-64 flex flex-col"
        [class.min-h-screen]="!isContentFillMode"
        [class.h-screen]="isContentFillMode"
        [class.min-h-0]="isContentFillMode">

    <!-- Header -->
    <header class="sticky top-0 z-30 pe-app-header flex items-center justify-between gap-4 px-4 lg:px-8">

      <!-- Left: Menu Toggle, Page Title & Organization Switcher -->
      <div class="flex items-center gap-4 min-w-0">
        <button (click)="toggleSidebar()"
                class="lg:hidden p-2 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>

        <div *ngIf="pageHeader$ | async as header" class="pe-app-header-heading hidden md:flex min-w-0 max-w-md">
          <div class="pe-app-header-heading__icon" aria-hidden="true">
            <app-page-header-icon [icon]="header.icon"></app-page-header-icon>
          </div>
          <div class="pe-app-header-heading__text min-w-0">
            <h1 class="pe-app-header-heading__title">{{ header.title }}</h1>
            <p *ngIf="header.subtitle" class="pe-app-header-heading__subtitle">{{ header.subtitle }}</p>
          </div>
        </div>

        <!-- Organization Switcher -->
        <div class="relative" *ngIf="currentOrg$ | async as currentOrg">
          <!-- Click outside to close dropdown - rendered first so dropdown is on top -->
          <div *ngIf="orgDropdownVisible" (click)="closeOrgDropdown()" class="fixed inset-0 z-40"></div>

          <button (click)="toggleOrgDropdown()"
                  class="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-slate-100 transition-colors border border-slate-200">
            <!-- Organization Icon -->
            <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-blue to-brand-navy flex items-center justify-center">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
              </svg>
            </div>
            <!-- Org Name -->
            <div class="hidden sm:block text-left max-w-[150px]">
              <div class="text-sm font-semibold text-slate-800 truncate">{{ currentOrg.organization_name }}</div>
              <div class="text-xs text-slate-500 capitalize">{{ currentOrg.role }}</div>
            </div>
            <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>

          <!-- Organization Dropdown -->
          <div *ngIf="orgDropdownVisible"
               class="absolute left-0 mt-2 w-72 bg-white rounded-xl shadow-lg border border-slate-200 py-2 z-50 animate-fade-in">
            <!-- Header -->
            <div class="px-4 py-3 border-b border-slate-100">
              <div class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Switch Organization</div>
            </div>

            <!-- Organization List -->
            <div class="max-h-64 overflow-y-auto py-1">
              <button *ngFor="let org of organizations$ | async"
                      (click)="switchOrganization(org)"
                      [disabled]="org.is_current || isSwitchingOrg"
                      class="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-slate-50 transition-colors"
                      [class.bg-blue-50]="org.is_current"
                      [class.cursor-not-allowed]="org.is_current">
                <!-- Org Icon -->
                <div class="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                     [class.bg-gradient-to-br]="true"
                     [class.from-brand-blue]="org.is_current"
                     [class.to-brand-navy]="org.is_current"
                     [class.from-slate-200]="!org.is_current"
                     [class.to-slate-300]="!org.is_current">
                  <svg class="w-5 h-5" [class.text-white]="org.is_current" [class.text-slate-600]="!org.is_current" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                  </svg>
                </div>
                <!-- Org Info -->
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2">
                    <span class="text-sm font-semibold text-slate-800 truncate">{{ org.organization_name }}</span>
                    <span *ngIf="org.is_current" class="text-xs bg-brand-blue text-white px-2 py-0.5 rounded-full">Current</span>
                  </div>
                  <div class="flex items-center gap-2 mt-0.5">
                    <span class="text-xs px-2 py-0.5 rounded-full" [ngClass]="getRoleBadgeClass(org.role)">{{ org.role | titlecase }}</span>
                    <span *ngIf="!org.is_complete" class="text-xs text-amber-600">Setup incomplete</span>
                  </div>
                </div>
                <!-- Check Icon -->
                <svg *ngIf="org.is_current" class="w-5 h-5 text-brand-blue flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </button>
            </div>

            <!-- Create New Organization -->
            <div class="border-t border-slate-100 pt-2 mt-1 px-2">
              <button (click)="openCreateOrgModal()"
                      class="w-full flex items-center gap-3 px-3 py-2.5 text-sm text-brand-blue hover:bg-blue-50 rounded-lg transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                </svg>
                Create New Organization
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="pe-app-header__actions">
        <button type="button" class="pe-icon-btn pe-icon-btn--ghost pe-notify-btn" aria-label="Notifications">
          <svg class="w-[1.125rem] h-[1.125rem]" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
          </svg>
          <span class="pe-notify-btn__dot" aria-hidden="true"></span>
        </button>

        <div class="relative" *ngIf="userProfile$ | async as profile">
          <div *ngIf="userDropdownVisible" (click)="closeUserDropdown()" class="fixed inset-0 z-40"></div>
          <button type="button" (click)="toggleUserDropdown()" class="pe-user-chip" aria-haspopup="menu" [attr.aria-expanded]="userDropdownVisible">
            <span class="pe-user-chip__avatar" aria-hidden="true">{{ getUserInitials(profile) }}</span>
            <span class="pe-user-chip__meta hidden sm:block">
              <span class="pe-user-chip__name">{{ getUserDisplayName(profile) }}</span>
              <span class="pe-user-chip__role">{{ getHeaderRoleLabel(profile) }}</span>
            </span>
            <svg class="pe-user-chip__chevron hidden sm:block" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>

          <!-- User Dropdown -->
          <div *ngIf="userDropdownVisible"
               class="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-slate-200 py-2 z-50 animate-fade-in">
            <!-- Header -->
            <div class="px-4 py-3 border-b border-slate-100">
              <div class="text-sm font-semibold text-slate-800">{{ profile.first_name }} {{ profile.last_name }}</div>
              <div class="text-xs text-slate-500 truncate">{{ profile.email }}</div>
            </div>

            <!-- Menu Items -->
            <div class="py-1">
              <a (click)="navigateToProfile()"
                 class="flex items-center gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 cursor-pointer transition-colors">
                <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
                My Profile
              </a>
              <a (click)="navigateToSettings()"
                 class="flex items-center gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 cursor-pointer transition-colors">
                <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                Settings
              </a>
              <a (click)="navigateToBilling()"
                 class="flex items-center gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 cursor-pointer transition-colors">
                <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                </svg>
                Billing
              </a>
            </div>

            <!-- Logout -->
            <div class="border-t border-slate-100 pt-1 mt-1">
              <a (click)="logout()"
                 class="flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 cursor-pointer transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
                </svg>
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!--
      Layout contract (authenticated shell):
      - Padding: only here (p-4 lg:px-8 lg:py-6). Pages must not add extra px-4 / py-6.
      - Max width: only here (max-w-[1600px] mx-auto). Pages must not wrap another max-w-7xl.
      - Page title: app-page-header as the first content landmark; optional backHref / [page-header-back].
      - Scroll: default overflow-y-auto on this pane. Fill routes use layout-content--fill
        (flex-1 min-h-0 overflow-hidden flex flex-col) so the child owns inner scroll.
    -->
    <div class="flex-1 p-4 lg:px-8 lg:py-6 bg-brand-bg"
         [class.overflow-y-auto]="!isContentFillMode"
         [class.layout-content--fill]="isContentFillMode"
         [class.min-h-0]="isContentFillMode"
         [class.overflow-hidden]="isContentFillMode"
         [class.flex]="isContentFillMode"
         [class.flex-col]="isContentFillMode">
      <div class="w-full max-w-[1600px] mx-auto"
           [class.layout-content-inner--fill]="isContentFillMode"
           [class.flex-1]="isContentFillMode"
           [class.min-h-0]="isContentFillMode"
           [class.flex]="isContentFillMode"
           [class.flex-col]="isContentFillMode"
           [class.w-full]="isContentFillMode">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>

<!-- Create Organization Modal -->
<app-modal
  [isOpen]="showCreateOrgModal"
  heading="Create New Organization"
  subtitle="Set up a new organization and become its owner"
  size="lg"
  [hasFooter]="false"
  (closed)="closeCreateOrgModal()">
    <form [formGroup]="createOrgForm" (ngSubmit)="createOrganization()" class="space-y-5">
      <!-- Organization Name -->
      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-2">Organization Name</label>
        <input type="text"
               formControlName="name"
               placeholder="Enter organization name"
               class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-brand-blue focus:border-transparent transition-all"
               [class.border-red-300]="createOrgForm.get('name')?.invalid && createOrgForm.get('name')?.touched">
        <p *ngIf="createOrgForm.get('name')?.invalid && createOrgForm.get('name')?.touched"
           class="text-sm text-red-500 mt-1">Organization name is required (2-100 characters)</p>
      </div>

      <!-- Company Size -->
      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-2">Company Size</label>
        <select formControlName="company_size"
                class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-brand-blue focus:border-transparent transition-all bg-white">
          <option value="">Select company size</option>
          <option value="1-10">1-10 employees</option>
          <option value="11-50">11-50 employees</option>
          <option value="51-200">51-200 employees</option>
          <option value="201-500">201-500 employees</option>
          <option value="501-1000">501-1000 employees</option>
          <option value="1000+">1000+ employees</option>
        </select>
      </div>

      <!-- Industry -->
      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-2">Industry</label>
        <select formControlName="industry"
                class="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-brand-blue focus:border-transparent transition-all bg-white">
          <option value="">Select industry</option>
          <option value="technology">Technology</option>
          <option value="finance">Finance & Banking</option>
          <option value="healthcare">Healthcare</option>
          <option value="retail">Retail & E-commerce</option>
          <option value="manufacturing">Manufacturing</option>
          <option value="education">Education</option>
          <option value="legal">Legal</option>
          <option value="real-estate">Real Estate</option>
          <option value="other">Other</option>
        </select>
      </div>

      <!-- Country -->
      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-2">Country</label>
        <app-country-phone-input
          formControlName="country"
          [countryOnly]="true"
          inputClass="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-brand-blue focus:border-transparent transition-all bg-white">
        </app-country-phone-input>
      </div>

      <!-- Set as Current -->
      <div class="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
        <input type="checkbox"
               formControlName="set_as_current"
               id="setAsCurrent"
               class="w-5 h-5 rounded border-slate-300 text-brand-blue focus:ring-brand-blue">
        <label for="setAsCurrent" class="text-sm text-slate-700">
          Switch to this organization after creation
        </label>
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-3 pt-4">
        <button type="submit"
                [disabled]="createOrgForm.invalid || isCreatingOrg"
                class="flex-1 px-6 py-3 bg-brand-blue text-white font-semibold rounded-xl hover:bg-blue-600 focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
          <svg *ngIf="isCreatingOrg" class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {{ isCreatingOrg ? 'Creating...' : 'Create Organization' }}
        </button>
        <button type="button"
                (click)="closeCreateOrgModal()"
                class="px-6 py-3 border border-slate-200 text-slate-700 font-semibold rounded-xl hover:bg-slate-50 transition-all">
          Cancel
        </button>
      </div>
    </form>
</app-modal>


